import { render, staticRenderFns } from "./vipuserjknew.vue?vue&type=template&id=9443df08&"
import script from "./vipuserjknew.vue?vue&type=script&lang=js&"
export * from "./vipuserjknew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports